
import { defineMessages } from 'react-intl';
const defaultMessages = defineMessages(
  {
    "rootIntegrationsGoogleSettingsAccountCreatingMessage": {
      "id": "root.integrations.google_settings.account_creating_message",
      "defaultMessage": "Google account is being set up. Please check back later."
    },
    "rootIntegrationsGoogleSettingsDateTime": {
      "id": "root.integrations.google_settings.date_time",
      "defaultMessage": "Date Time"
    },
    "rootIntegrationsGoogleSettingsFalse": {
      "id": "root.integrations.google_settings.false",
      "defaultMessage": "No"
    },
    "rootIntegrationsGoogleSettingsMessage": {
      "id": "root.integrations.google_settings.message",
      "defaultMessage": "Message"
    },
    "rootIntegrationsGoogleSettingsSelf": {
      "id": "root.integrations.google_settings.self",
      "defaultMessage": "Settings"
    },
    "rootIntegrationsGoogleSettingsSiteMapSubmitted": {
      "id": "root.integrations.google_settings.site_map_submitted",
      "defaultMessage": "Site Map Submitted"
    },
    "rootIntegrationsGoogleSettingsSiteVerified": {
      "id": "root.integrations.google_settings.site_verified",
      "defaultMessage": "Site Verified"
    },
    "rootIntegrationsGoogleSettingsStatus": {
      "id": "root.integrations.google_settings.status",
      "defaultMessage": "Status"
    },
    "rootIntegrationsGoogleSettingsTrue": {
      "id": "root.integrations.google_settings.true",
      "defaultMessage": "Yes"
    },
    "rootIntegrationsEnable": {
      "id": "root.integrations.enable",
      "defaultMessage": "Enable"
    },
    "rootStatsBillingSubscriptionsHeader": {
      "id": "root.stats.billing_subscriptions.header",
      "defaultMessage": "Subscriptions"
    },
    "rootTasksCreate": {
      "id": "root.tasks.create",
      "defaultMessage": "Create Task"
    },
    "rootTasksTitle": {
      "id": "root.tasks.title",
      "defaultMessage": "Tasks"
    },
    "rootStatsBillingSubscriptionsUpcomingInvoiceTotal": {
      "id": "root.stats.billing_subscriptions.upcoming_invoice_total",
      "defaultMessage": "Upcoming Invoices Total"
    },
  }
);
export default defaultMessages;

